export default {
  fontFamily: {
    fontPrimary: "Roboto",
    fontSecondary: "Nunito",
  },
};
